import {
  Box,
  Checkbox,
  FormControlLabel,
  Link,
  Typography,
  Modal,
  Button,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useRef } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "80%",
    sm: "70%",
    md: "60%",
    lg: "40%",
    xl: "40%",
  },
  maxHeight: "80vh",
  overflowY: "auto",
  background: "white",
  border: "1px solid #000",
  borderRadius: 2,
  boxShadow: 24,
  fontSize: "1rem",
  p: 4,
};

const Termos = ({
  setTermos,
  termos,
  setConfirmacaoReplicacao,
  confirmacaoReplicacao,
  showConfirmacaoReplicacao,
}) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const termosRef = useRef(null);

  const scrollToBottom = () => {
    termosRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box
      textAlign="center"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <FormControlLabel
        control={
          <Checkbox
            value="Eu concordo com os termos de uso."
            name="Eu concordo com os termos de uso."
            checked={termos}
            onChange={(e) => {
              handleOpen();
              //setTermos(e.target.checked)
            }}
          />
        }
        label={
          <>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
            >
              <Typography variant="body1" fontFamily="Montserrat">
                Eu concordo com os termos de uso.{" "}
                <Link
                  href="https://papello.com.br/termos-de-uso"
                  target="_blank"
                  fontFamily="Montserrat"
                >
                  *Ler termos de uso{" "}
                </Link>
              </Typography>
            </Box>
          </>
        }
      />
      {showConfirmacaoReplicacao && (
        <FormControlLabel
          control={
            <Checkbox
              value="Eu concordo em replicar minha arte do pedido anterior."
              name="Eu concordo em replicar minha arte do pedido anterior."
              checked={confirmacaoReplicacao}
              onChange={(e) => setConfirmacaoReplicacao(e.target.checked)}
            />
          }
          label={
            <>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
              >
                <Typography variant="body1" fontFamily="Montserrat">
                  Eu concordo em replicar minha arte do pedido anterior{" "}
                  <span style={{ color: "red", fontWeight: "bold" }}>
                    SEM NENHUM TIPO DE ALTERAÇÃO.
                  </span>
                </Typography>
              </Box>
            </>
          }
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        overflowY="scroll"
      >
          <Box

            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "80%", sm: "70%", md: "60%", lg: "40%", xl: "40%" },
              height: "80vh",
              background: "transparent",
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
              display: "flex",
              flexDirection: "column",
            }}
          >
          <Box
            sx={{
              ...style,
              maxHeight: "80vh",
              
              overflowY: "auto", // Permite rolagem dentro do modal
              width: { xs: "80%", sm: "100%", md: "100%", lg: "100%", xl: "100%" },
              position: "absolute", // Para o botão ser posicionado corretamente dentro do modal
              paddingBottom: "60px", // Evita que o botão sobreponha o conteúdo ao rolar
            }}
          >
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            fontWeight="bold"
            textAlign="center"
          >
            TERMOS DE SERVIÇO E USO - PAPELLO EMBALAGENS
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            textAlign="center"
          >
        <Typography id="modal-modal-description" sx={{ mt: 2 }} textAlign="left">
          <Typography  fontWeight="bold"  paragraph>
            AO CLICAR EM "Eu aceito os termos de uso", O USUÁRIO CONCORDA COM ESTES TERMOS DE USO DA PAPELLO SOLUÇÕES EM EMBALAGENS, pessoa jurídica de direito privado, inscrita no CNPJ/MF nº 21.153.371/0001-83, estabelecida no Polo de Desenvolvimento JK, Trecho 01, Conjuntos 09 e 10 – Santa Maria – Brasília – DF, CEP 72.549-545, que presta serviços através do site <a href="https://www.papello.com.br" >www.papello.com.br</a>, por e-mail ou telefone.
          </Typography>

          <Typography variant="h6" component="h3" fontWeight="bold">
            1 - PEDIDO
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.1 - A produção do pedido somente será iniciada após a confirmação do pagamento, realizado através dos métodos de pagamento aceitos pela Papello. Caso o pagamento não seja confirmado ou a transação seja recusada por qualquer motivo, o pedido será automaticamente cancelado.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.2 - Os métodos de pagamento aceitos são:
          </Typography>
          <Typography fontWeight="600" paragraph>
            - Boleto bancário
            <br />
            - Pix
            <br />
            - Link de pagamento
            <br />
            - Cartão de crédito
            <br />
            - Cartão de débito
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.2.1 - Prazos de aprovação dos pagamentos:
            <br />
            - Pix e Cartão de Crédito: aprovação imediata.
            <br />
            - Demais formas de pagamento: o prazo para comprovação e efetivação pode levar até 2 dias úteis.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.3 - Envio e Aprovação da Arte:
            <br />
            - O usuário deve enviar sua arte através do Formulário de Arte (briefing), disponível na área do cliente no site.
            <br />
            - O layout deve ser aprovado em até 20 dias após a confirmação do pagamento.
            <br />
            - Caso o usuário não aprove a arte dentro desse prazo, o valor do pedido será automaticamente convertido em crédito na conta do usuário, válido para futuras compras no site, independentemente do produto.
            <br />
            - Esse procedimento se aplica mesmo se o cliente já possuir uma arte finalizada e não a submeter para aprovação no prazo estabelecido.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.3.1 - O crédito gerado não poderá, em nenhuma hipótese, ser convertido em dinheiro para devolução ao usuário.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.3.2 - A criação de arte fornecida pela Papello não inclui:
            <br />
            - Criação de textos e imagens;
            <br />
            - Edição, vetorização ou criação de logotipos.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.4 - Assinatura da Papello nos produtos:
            <br />
            - Todos os produtos terão impressas informações da Papello em um local de menor destaque, conforme o gabarito aprovado.
            <br />
            - Essas informações não podem ser removidas ou alteradas sob nenhuma circunstância.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.5 - Responsabilidade sobre o conteúdo da arte enviada pelo usuário:
            <br />
            - A Papello não se responsabiliza pelo conteúdo enviado pelo usuário caso ele seja ilegal, infrinja ou viole os direitos de terceiros.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.6 - O usuário se compromete a isentar, indenizar e defender a Papello em caso de qualquer violação de direitos de terceiros decorrente dos arquivos que ele enviou.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.7 - Caso o arquivo enviado não atenda às especificações técnicas exigidas, a arte não será aprovada para produção.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.8 - Cancelamento e Pausa da Produção:
            <br />
            - A Papello não realiza cancelamentos ou pausas na produção de pedidos cujo status esteja como “Arte Liberada para Produção”.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.9 - Alteração de pedidos antes da produção:
            <br />
            - Se o usuário precisar alterar um item no pedido, ele deve entrar em contato com o SAC pelos canais disponíveis (e-mail, WhatsApp ou telefone) para solicitar o cancelamento e refazer o processo de compra.
            <br />
            - O cancelamento e reembolso só serão possíveis se o pedido ainda não estiver com o status “Arte Liberada para Produção”.
            <br />
            - Caso a produção já tenha sido liberada, alterações não serão permitidas.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.10 - Pedidos não podem ser alterados após a aprovação da arte para produção.
          </Typography>
          <Typography fontWeight="600" paragraph>
            1.11 - Prazos de produção e eventuais atrasos:
            <br />
            - A maioria dos pedidos são entregues dentro do prazo estipulado no momento da compra.
            <br />
            - Entretanto, devido à escassez de matéria-prima no mercado ou a falhas mecânicas, o prazo de produção pode sofrer um atraso de até 15 dias úteis.
            <br />
            - Não serão aceitos pedidos de cancelamento motivados por atrasos dentro desse período.
          </Typography>

          <Typography variant="h6" component="h3" fontWeight="bold">
            2 - TERMOS PARA PREENCHIMENTO DO FORMULÁRIO DE PERSONALIZAÇÃO
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.1 - O Formulário de Personalização deve ser preenchido pelo usuário em até 20 dias após a aprovação da compra. A comunicação sobre o preenchimento será feita via site, e-mail e/ou WhatsApp do SAC.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.2 - Após o preenchimento do Formulário de Arte (briefing), os arquivos e conteúdos enviados pelo cliente serão analisados em até 1 dia útil. O envio do modelo virtual para aprovação será feito em até 3 dias úteis.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.3 - Caso o arquivo enviado não siga os requisitos técnicos e seja reprovado, o usuário terá até 20 dias para enviar um novo arquivo que atenda aos requisitos estabelecidos, contados a partir da data de reprovação.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.4 - Se a arte for criada pela equipe da Papello, o prazo para envio de alterações solicitadas pelo cliente será de até 2 dias úteis.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.4.1 - A arte criada pela Papello não será disponibilizada ao cliente para outros usos. Ela permanecerá de propriedade da Papello.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.5 - O prazo de entrega do pedido só começa a contar após a aprovação final da arte enviada e/ou replicada.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.6 - A quantidade de artes por item a ser confeccionado é definida no momento da compra e não pode ser alterada após o pedido ser processado.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.7 - O usuário tem direito a até 3 alterações sem custo adicional. Alterações extras serão cobradas no valor de R$ 20,00 por alteração, pagas via link de pagamento enviado pelo SAC.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8 - O usuário é inteiramente responsável por garantir que os arquivos enviados atendam aos requisitos mínimos para aprovação do Formulário de Arte.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.1 - Imagens devem ser editáveis e possuir resolução mínima de 300dpi.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.2 - Textos na logomarca devem estar convertidos para vetor, garantindo a qualidade na impressão.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.3 - A comunicação sobre a criação da arte ocorre estritamente na área do cliente no site. O usuário pode esclarecer dúvidas através dos canais de atendimento (SAC via WhatsApp, telefone ou e-mail).
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.4 - A Papello não cria nem edita logotipos.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.5 - A Papello não cria textos. Se o usuário deseja incluir alguma frase ou texto na arte, ele deve informar o texto exato e a fonte a ser utilizada.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.6 - A Papello não realiza revisões ortográficas. A responsabilidade pela conferência e aprovação da arte final é exclusiva do cliente.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.7 - Após a aprovação da arte, nenhuma alteração será aceita. O usuário deve revisar atentamente sua arte antes de aprová-la, pois, uma vez aprovada, não serão aceitas reclamações ou modificações.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.8 - Preenchimento detalhado do Formulário de Arte:
            <br />
            - O usuário deve preencher o formulário com o máximo de informações possíveis.
            <br />
            - É recomendável enviar referências visuais, facilitando a criação de uma arte alinhada às expectativas do cliente.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.9 - Uso de QR Code em superfícies arredondadas:
            <br />
            - QR Codes aplicados em áreas curvas podem não funcionar corretamente.
            <br />
            - A Papello não se responsabiliza por eventuais falhas na leitura do QR Code em embalagens arredondadas.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.10 - Responsabilidade pelo acompanhamento da arte:
            <br />
            - É exclusiva do usuário a responsabilidade de verificar seu e-mail para acompanhar o status da arte enviada, solicitar alterações e aprovar o arquivo para produção.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.11 - O usuário pode optar por enviar a arte já finalizada utilizando um dos gabaritos disponibilizados pela Papello. Para isso, deve solicitar o arquivo ao SAC.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.12 - Arquivos enviados serão analisados pela equipe de designers em até 2 dias úteis para verificar sua conformidade com os padrões exigidos.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.8.13 - Formatos de arquivos aceitos:
            <br />
            - Corel Draw (CDR), Adobe Illustrator (AI), Adobe Photoshop (PSD), Adobe Indesign (INDD) e PDF X4.
            <br />
            - Todos os arquivos devem estar em alta resolução (mínimo de 300dpi).
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.9 - Cores e Variações na Impressão
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.9.1 - A Papello utiliza a escala de cores CMYK para impressão.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.9.2 - Pode ocorrer uma variação de até 10% entre as cores visualizadas na tela e a impressão final. Essa diferença pode ocorrer devido:
            <br />
            - À variação entre monitores e dispositivos;
            <br />
            - À configuração do software de edição;
            <br />
            - Ao tipo de material impresso.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.9.3 - Variações de cor não caracterizam defeito e não são passíveis de reimpressão.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.9.4 - Pequenas diferenças de tonalidade podem ocorrer entre embalagens de tamanhos diferentes, mesmo quando possuem a mesma arte.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.9.5 - Se o usuário deseja que a impressão tenha uma cor específica, ele deve informar o código da cor na escala CMYK no momento do preenchimento do Formulário de Arte.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.9.6 - Caso nenhuma cor seja especificada, a impressão será realizada de acordo com a cor enviada no arquivo final pelo usuário.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.9.7 - Embalagens que possuem cores escuras ou alta carga de tinta podem apresentar odor mais forte da tinta.
          </Typography>
          <Typography fontWeight="600" paragraph>
            2.9.8 - O odor da tinta não compromete a qualidade ou segurança da embalagem, pois são utilizados insumos 100% atóxicos.
          </Typography>

          <Typography variant="h6" component="h3" fontWeight="bold">
            3 - FRETE E LOGÍSTICA
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.1 - O prazo de entrega começa a ser contado somente após a aprovação final da arte para produção.
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.1.1 - Produtos diferentes podem possuir prazos de entrega distintos. O usuário deve considerar o prazo do produto com maior tempo de produção para calcular a data estimada de recebimento.
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.2 - A disponibilidade e o prazo de entrega serão determinados de acordo com o CEP e endereço informado no momento da compra.
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.3 - Recusa no recebimento do pedido:
            <br />
            - O usuário deve recusar o recebimento do pedido caso ocorra alguma das situações abaixo:
            <br />
            3.3.1 - Embalagem aberta ou avariada;
            <br />
            3.3.2 - Produto avariado;
            <br />
            3.3.3 - Divergência entre o produto recebido e o que foi solicitado no pedido;
            <br />
            - Se o usuário aceitar o produto mesmo com avarias e assinar o comprovante de recebimento, ele assume total responsabilidade pela qualidade do item e não poderá solicitar reembolso ou troca posteriormente.
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.4 - Responsabilidade do cliente no recebimento:
            <br />
            - O usuário deve garantir que haja uma pessoa maior de 18 anos no local de entrega para receber o pedido no horário informado pela transportadora.
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.5 - Alteração de endereço de entrega:
            <br />
            - Caso o cliente precise alterar o endereço de entrega, a solicitação deve ser feita antes do envio do pedido.
            <br />
            - A alteração estará sujeita à verificação de disponibilidade e, caso seja possível, pode ser necessário recalcular o frete, sendo que o usuário deverá pagar a diferença antes do envio do pedido.
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.5.1 - Se o pedido já tiver sido despachado, não será possível alterar o endereço de entrega.
            <br />
            - Caso o produto seja enviado para o endereço incorreto por erro do usuário, ele será responsável pelo custo de reenvio.
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.6 - Responsabilidade por informações incorretas:
            <br />
            - A Papello não se responsabiliza por atrasos ou extravios causados por informações de endereço incorretas ou incompletas fornecidas pelo cliente.
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.7 - Entrega no endereço informado pelo usuário:
            <br />
            - O pedido será entregue a qualquer pessoa presente no endereço cadastrado no momento da compra.
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.8 - Reentregas e custos adicionais:
            <br />
            - Caso a transportadora tente realizar a entrega e não haja ninguém disponível para receber o pedido, poderá haver a cobrança de taxa de reentrega.
            <br />
            - Nesse caso, o cliente deverá entrar em contato diretamente com a transportadora informada no ato da compra para tratar os custos e prazos da nova entrega.
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.9 - Prazo e acompanhamento da entrega:
            <br />
            - A Papello realiza o transporte direto apenas para entregas de cargas no DF e entorno. Para demais localidades, a entrega é feita por transportadoras terceirizadas.
            <br />
            - A Papello não se responsabiliza por atrasos causados pelas transportadoras, sendo de responsabilidade do cliente acompanhar a entrega pelo site da transportadora informada no momento da compra.
            <br />
            - Caso o cliente deseje antecipar a entrega, essa solicitação deverá ser feita diretamente à transportadora.
          </Typography>
          <Typography fontWeight="600" paragraph>
            3.10 - Comprovação da entrega:
            <br />
            - A entrega será considerada concluída a partir do momento em que a transportadora confirmar que o produto foi entregue ao usuário.
            <br />
            - O usuário pode consultar a comprovação de entrega no sistema de rastreamento da transportadora.
          </Typography>


          <Typography variant="h6" component="h3" fontWeight="bold">
            4 - CANCELAMENTO, RECLAMAÇÃO, DEVOLUÇÃO E REIMPRESSÃO
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.1 - Para qualquer reclamação, solicitação ou dúvida, o usuário deve entrar em contato com a Central de Atendimento ao Cliente da Papello através do WhatsApp ou pelo e-mail sac@papello.com.br.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.2 - Cancelamento e Reembolso
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.2.1 - "Após a aprovação da arte final, a produção será iniciada e não será possível o cancelamento ou reembolso, pois trata-se de um produto personalizado, sem possibilidade de reutilização. O cliente declara ciência de que a aprovação da arte implica na aceitação da produção, sem direito a cancelamento ou estorno, independentemente do motivo da desistência. Qualquer valor pago não será devolvido e nem convertido em crédito, exceto em casos de falha comprovada na execução da produção pela Papello."
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.2.2 - O usuário pode solicitar o cancelamento do pedido com reembolso integral dentro do prazo de 7 dias corridos após a aprovação do pagamento, desde que a arte ainda não tenha sido aprovada para produção.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.2.3 - Após esse prazo ou caso a arte já tenha sido aprovada para produção, o valor pago será convertido em crédito na conta do usuário, podendo ser utilizado em compras futuras no site da Papello, sem possibilidade de reembolso em dinheiro.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.2.4 - O prazo para análise de cancelamento é de até 3 dias úteis.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.2.5 - Caso o cancelamento seja aprovado, o reembolso ou crédito será processado em até 3 dias úteis, descontadas eventuais taxas bancárias aplicáveis.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.2.6 - Pedidos já entregues não podem ser devolvidos, pois são personalizados.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.2.7 - A Papello não aceita devoluções de produtos personalizados e exclusivos, uma vez que são produzidos sob medida para o cliente.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.2.8 - Todo produto personalizado da Papello somente será liberado para produção após a aprovação formal do cliente em sua área do cliente.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.2.9 - A Papello se reserva o direito de não cancelar ou pausar a produção de pedidos cujo status já esteja como "Arte Liberada para Produção".
          </Typography>

          <Typography fontWeight="600" paragraph>
            4.3 - Reclamações por Defeito ou Quantidade Incorreta
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.3.1 - Se o usuário receber um produto com defeito, ele deve registrar a solicitação de troca pelo e-mail sac@papello.com.br dentro de 15 dias corridos após o recebimento do pedido.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.3.2 - Reclamações sobre quantidade incorreta devem ser feitas em até 5 dias úteis após o recebimento do pedido.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.3.3 - Para que a reclamação seja analisada, o usuário deve enviar as seguintes evidências:
            <br />
            - Fotos do defeito visível no material recebido;
            <br />
            - Foto mostrando a quantidade total do material defeituoso;
            <br/>
            - Vídeo explicativo, caso solicitado pela equipe técnica da Papello.
            </Typography>
            <Typography fontWeight="600" paragraph>
            4.3.4 - Caso seja comprovado que mais de 20% do material recebido apresenta defeitos, o usuário poderá optar por:
            - Reimpressão gratuita do material defeituoso, ou
            <br/>
            - Reembolso proporcional ao valor do material com defeito (em dinheiro ou crédito na conta do usuário, válido por 6 meses).
            </Typography>
            <Typography fontWeight="600" paragraph>
            4.3.5 - O prazo para análise da reclamação e retorno ao usuário é de até 3 dias úteis após o envio das evidências.
            </Typography>

            <Typography fontWeight="600" paragraph>
            4.4 - Política de Reimpressão e Condições de Uso
            </Typography>
            <Typography fontWeight="600" paragraph>
            4.4.1 - A Papello não realiza reimpressão do material em casos de:
            <br/>
            - Alegação de baixa rigidez do papel;
            <br/>
            - Erros na arte aprovados pelo cliente antes da produção;
            <br/>
            - Variação de tonalidade e intensidade de cor entre a tela do monitor e a impressão final, reimpressões ou dentro do mesmo lote.
            </Typography>
            <Typography fontWeight="600" paragraph>
            4.4.2 - Pequenas variações de cor podem ocorrer entre lotes distintos ou até mesmo entre folhas individuais do mesmo lote, sem que isso seja considerado erro de impressão.
            </Typography>
            <Typography fontWeight="600" paragraph>
            4.4.3 - Se a Papello analisar como procedente a reclamação do usuário, poderá ser realizada:
            <br/>
             - Reimpressão do material sem custo adicional, ou Reembolso proporcional ao valor do material defeituoso (em dinheiro ou crédito na conta do usuário, válido por 6 meses).
            </Typography>
            <Typography fontWeight="600" paragraph>
              4.4.4 - O material defeituoso deve ser devolvido à Papello para que a reimpressão seja realizada.
            </Typography>
            <Typography fontWeight="600" paragraph>
            4.4.5 - Para que a devolução seja aceita, o material deve estar sem sinais de uso e na embalagem original.
            </Typography>
            <Typography fontWeight="600" paragraph>
            4.4.6 - O prazo limite para contestação de um material defeituoso é de 15 dias corridos após o recebimento do pedido.
            </Typography>
            <Typography fontWeight="600" paragraph>
            4.4.7 - Custos de frete para devolução do material defeituoso:
            
            <br/>
            - Se a devolução ocorrer em até 10 dias úteis, a Papello arcará com o custo do frete.
            <br/>

           - Se a devolução ocorrer após 10 dias úteis, o cliente será responsável pelo custo do frete de devolução e do frete para reimpressão.
           </Typography>
          <Typography fontWeight="600" paragraph>
            4.5 - Condições Especiais e Fatores Operacionais
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.5.1 - Em casos excepcionais, a Papello poderá oferecer reembolso ou crédito no site caso ocorra perda de material por fatores operacionais.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.5.2 - Perda de até 10% do total adquirido devido a fatores operacionais pode ocorrer em raros casos. Nessa situação, o valor proporcional poderá ser:
            <br/>
            - Reembolsado ao cliente via estorno, ou Convertido em crédito na plataforma, para ser usado em pedidos futuros.
          </Typography>
          <Typography fontWeight="600" paragraph>
            4.5.3 - Pedidos já enviados não poderão ser cancelados devido a atrasos de até 15 dias úteis, causados por fatores como:
            <br/>
            - Escassez de matéria-prima;
            <br/>
            - Alta demanda no mercado;
            <br/>
            - Falhas mecânicas na produção.
          </Typography>
          <Typography variant="h6" component="h3" fontWeight="bold">
            5 - PROTEÇÃO DE DADOS E PRIVACIDADE
          </Typography>
          <Typography fontWeight="600" paragraph>
            5.1 - A Papello está comprometida com a proteção de dados pessoais de seus clientes, fornecedores e parceiros, garantindo total conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei 13.709/2018).
          </Typography>
          <Typography fontWeight="600" paragraph>
            5.2 - A coleta, armazenamento e tratamento de dados pessoais são realizados com transparência, segurança e respeito aos direitos dos titulares.
          </Typography>
          <Typography fontWeight="600" paragraph>
            5.3 - Coleta e Finalidade dos Dados Pessoais
          </Typography>
          <Typography fontWeight="600" paragraph>
            5.3.1 - Os dados pessoais coletados pela Papello são utilizados exclusivamente para os seguintes fins:
            <br/>
            - Processamento de pedidos e emissão de notas fiscais;
            <br/>
            - Entrega de produtos e rastreamento de pedidos;
            <br/>
            - Comunicação com o cliente para suporte e atendimento;
            <br/>
            - Cumprimento de obrigações legais e regulatórias;
            <br/>
            - Melhoria dos serviços oferecidos pela Papello.
            <br />
          </Typography>
            <Typography fontWeight="600" paragraph>
            5.3.2 - Os dados são coletados por meio do site, e-mail, telefone ou canais digitais utilizados para comunicação com a empresa.
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.4 - Armazenamento e Segurança dos Dados
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.4.1 - A Papello adota medidas técnicas e organizacionais para garantir a proteção e confidencialidade dos dados pessoais armazenados.
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.4.2 - O acesso aos dados é restrito a profissionais autorizados, que possuem dever de sigilo e confidencialidade.
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.4.3 - Os dados pessoais são armazenados pelo tempo necessário para cumprir a finalidade para a qual foram coletados, respeitando os prazos exigidos por lei ou regulamentos aplicáveis.
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.4.4 - Caso o titular dos dados solicite a exclusão de suas informações, a Papello poderá manter determinados dados armazenados por obrigações legais, tais como exigências fiscais e contratuais.
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.5 - Compartilhamento de Dados com Terceiros
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.5.1 - A Papello não vende, compartilha ou comercializa dados pessoais com terceiros, exceto nos seguintes casos:
            <br/>
             - Para cumprimento de obrigações legais ou regulatórias;
            <br/>
            - Com parceiros logísticos e transportadoras, exclusivamente para a entrega dos pedidos;
            <br/>
            - Com prestadores de serviços financeiros, para processar pagamentos e transações bancárias;
            <br/>
            - Com autoridades competentes, caso haja solicitação judicial ou administrativa.
            <br/>
            </Typography>
            <Typography fontWeight="600" paragraph>          
            5.5.2 - Em todos os casos de compartilhamento, a Papello exige que os terceiros envolvidos também cumpram com a LGPD, garantindo a segurança das informações.
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.6 - Direitos do Titular dos Dados
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.6.1 - O usuário pode exercer seus direitos sobre seus dados pessoais a qualquer momento, incluindo:
            <br/>
              -Solicitar informações sobre o tratamento dos seus dados;
            <br/>
            - Corrigir, atualizar ou excluir seus dados pessoais;
            <br/>
            - Revogar o consentimento para uso de seus dados (quando aplicável);
            <br/>
            - Solicitar a portabilidade dos dados para outra empresa;
            <br/>
            - Opor-se ao tratamento de seus dados em determinadas situações.
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.6.2 - Para exercer seus direitos, o usuário pode entrar em contato pelo e-mail sac@papello.com.br.
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.7 - Alterações nesta Política de Proteção de Dados
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.7.1 - A Papello pode alterar esta política de proteção de dados a qualquer momento, para garantir conformidade com novas legislações e aprimoramento dos serviços.
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.7.2 - Caso as alterações impactem os direitos dos usuários, a Papello informará as mudanças com antecedência mínima de 7 dias.
            </Typography>
            <Typography fontWeight="600" paragraph>
            5.7.3 - O uso contínuo dos serviços após as alterações significa aceitação das novas condições.
            </Typography>
            <Typography variant="h6" component="h3" fontWeight="bold">
            6 - DISPOSIÇÕES FINAIS
            </Typography>
            <Typography fontWeight="600" paragraph>
            6.1 - A Papello oferece serviços e produtos gráficos personalizados sob encomenda.
            </Typography>
            <Typography fontWeight="600" paragraph>
            6.1.1 - Além dos produtos personalizados mencionados acima, a Papello poderá oferecer produtos prontos não personalizados através do seu site ou outros canais de vendas.
            </Typography>
            <Typography fontWeight="600" paragraph>
            6.2 - Estes Termos de Uso constituem o acordo integral entre as partes, prevalecendo sobre qualquer outro entendimento firmado anteriormente.
            </Typography>
            <Typography fontWeight="600" paragraph>
            6.3 - A Papello poderá divulgar notificações ou mensagens através do site, e-mail ou outros meios para informar o usuário sobre alterações nos serviços, políticas ou nestes Termos de Uso.
            </Typography>
            <Typography fontWeight="600" paragraph>
            6.4 - Legislação e Foro:
            <br/>
            - Estes Termos de Uso e o relacionamento entre as partes serão regidos e interpretados de acordo com as leis da República Federativa do Brasil.
            <br/>
            - Para resolver qualquer dúvida, pendência ou litígio relacionado a estes Termos de Uso, fica eleito o Foro da Comarca de Brasília - DF, com expressa renúncia a qualquer outro, por mais privilegiado que seja.
            </Typography>
            <Typography fontWeight="600" paragraph>
            6.5 - As regras referentes a promoções, programas de desconto ou campanhas específicas de venda, serão divulgadas em anúncio próprio. O usuário deverá se informar sobre os termos e condições aplicáveis a essas campanhas antes de realizar qualquer compra relacionada a elas.
           </Typography>
           </Typography>
          </Typography>
          <Box display="flex" justifyContent="center" margin="10px" >
          <Button
              ref={termosRef}
              onClick={() => {
                  setTermos(true);
                  handleClose();
              }}
              color="success"
              variant="contained"
              sx={{
                alignSelf: "center",
                width: {
                  xs: "100%",
                  sm: "80%",
                  md: "60%",
                  lg: "50%",
                  xl: "50%",
                },
              }}
            >
              Eu aceito os termos de uso
            </Button>
            <Box display="flex" justifyContent="center" margin="10px" />
            </Box>
        </Box>
         {/* Botão fixo dentro do modal */}
        <Box
            sx={{
              position: "fixed",
              bottom: 1,
              right: 1,
              zIndex: 9999, // Garante que o botão fique sobreposto a outros elementos
              p: 1, // Espaçamento interno para melhorar aparência
            }}
          >
          <button
            onClick={scrollToBottom}
            style={{
              cursor: "pointer",
              borderRadius: "20px",
              border: "none",
              textAlign: "center",
              padding: "10px 20px",
              backgroundColor: "#007BFF", // Cor de fundo vibrante
              color: "#fff", // Cor do texto contrastante
              display: "flex",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: "16px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Sombra para efeito de elevação
              transition: "background-color 0.3s ease", // Transição suave
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#0056b3")} // Cor de fundo ao passar o mouse
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#007BFF")} // Cor de fundo ao remover o mouse
          >
            Rolar até o final <ExpandMoreIcon style={{ marginLeft: "8px" }} />
          </button>
          </Box>

        </Box>
      </Modal>
    </Box>

  );
};

export default Termos;
